import React, { useEffect } from 'react';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Settings as SettingsIcon } from '@material-ui/icons';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { WhatsAppAuth } from '../WhatsAppAuth';
import {
	SettingsContainer,
	SettingsHeader,
	BackButton,
	SettingsTitle,
	SettingsContent,
	SettingsOption,
	SectionLabel,
} from './styles';
import { ArrowBackIos, ChevronRight } from '@material-ui/icons';
import { abstractDataUser, isAdmin, getWhatsappUserInfo } from 'util/isAdmin';
import Prompts from '../Prompts';
import MetaApiConfig from '../MetaApiConfig';
import WhatsappHealth from '../WhatsappHealth';
import TemplateConfig from '../TemplateConfig';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import {
	SETTINGS_VIEW_ATENDIMENTO as MENU_ATENDIMENTO,
	SETTINGS_VIEW_META_CONFIG as MENU_META_CONFIG,
	SETTINGS_VIEW_HEALTH as MENU_HEALTH,
	SETTINGS_VIEW_TEMPLATE_CONFIG as MENU_TEMPLATE_CONFIG,
} from 'newComponents/ChatWhatsapp/utils/whatsappSIdebarTabs';

const Settings = ( { onBack, onLogout, qrCode, isAuthenticated, isLoading } ) => {
	const isAdminProfileType = getWhatsappUserInfo()?.profile_type_id === 1;
	// view mantida no contexto para permitir abrir direto uma seção das configurações
	const { hasMetaApi, settingsView: oficialView, setSettingsView: setOficialView } = useMessage();

	const permittedUser = isAdmin() || [ 414, 280, 247,277,144,626,709,78,65,169,75,37,173, 915, 1243, 6, 1269 ].includes( abstractDataUser()?.tenantId );

	const showNaoOficial = isAuthenticated && permittedUser;
	const showOficial = isAdminProfileType && hasMetaApi;
	const showMetaConfig = isAdminProfileType;

	// limpa a seção aberta ao sair das configurações
	useEffect( () => () => setOficialView( null ), [] ); //eslint-disable-line

	const handleBack = () => {
		// "Configurar template" é aberta a partir da Saúde do WhatsApp e volta para ela
		if ( oficialView === MENU_TEMPLATE_CONFIG ) {
			setOficialView( MENU_HEALTH );
		} else if ( oficialView ) {
			setOficialView( null );
		} else {
			onBack();
		}
	};

	const headerTitle = oficialView === MENU_ATENDIMENTO ? 'Configurações de Atendimento'
		: oficialView === MENU_META_CONFIG ? 'Integração Meta API'
			: oficialView === MENU_HEALTH ? 'Saúde do WhatsApp'
				: oficialView === MENU_TEMPLATE_CONFIG ? 'Configurar template'
					: 'Configurações';

	return (
		<SettingsContainer>
			<SettingsHeader>
				<BackButton onClick={handleBack}>
					<ArrowBackIos />
				</BackButton>
				<SettingsTitle className='text-white'>{headerTitle}</SettingsTitle>
			</SettingsHeader>

			<SettingsContent style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

				{oficialView === MENU_ATENDIMENTO && <Prompts />}
				{oficialView === MENU_META_CONFIG && <MetaApiConfig />}
				{oficialView === MENU_HEALTH && <WhatsappHealth />}
				{oficialView === MENU_TEMPLATE_CONFIG && <TemplateConfig />}

				{!oficialView && (
					<>
						{( showNaoOficial || showOficial ) && (
							<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
								<SectionLabel>Atendimento</SectionLabel>
								<SettingsOption onClick={() => setOficialView( MENU_ATENDIMENTO )}>
									<SettingsIcon />
									<span style={{ flex: 1 }}>Configurações de Atendimento</span>
									<ChevronRight style={{ color: '#aaa' }} />
								</SettingsOption>
							</div>
						)}

						{showNaoOficial && (
							<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
								<SectionLabel>WhatsApp Não Oficial</SectionLabel>
								<WhatsAppAuth
									qrCode={qrCode}
									isAuthenticated={isAuthenticated}
									isLoading={isLoading}
								/>
								<SettingsOption
									onClick={isAdminProfileType ? onLogout : undefined}
									disabled={!isAdminProfileType}
								>
									<ExitToAppIcon />
									<span>Desconectar whatsapp</span>
								</SettingsOption>
							</div>
						)}

						{( showOficial || showMetaConfig ) && (
							<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
								<SectionLabel>WhatsApp Oficial (Meta)</SectionLabel>
								{showMetaConfig && (
									<SettingsOption onClick={() => setOficialView( MENU_META_CONFIG )}>
										<IntegrationInstructionsIcon />
										<span style={{ flex: 1 }}>Integração Meta API</span>
										<ChevronRight style={{ color: '#aaa' }} />
									</SettingsOption>
								)}
								{showOficial && (
									<SettingsOption onClick={() => setOficialView( MENU_HEALTH )}>
										<MonitorHeartIcon />
										<span style={{ flex: 1 }}>Saúde do WhatsApp</span>
										<ChevronRight style={{ color: '#aaa' }} />
									</SettingsOption>
								)}
							</div>
						)}
					</>
				)}

			</SettingsContent>
		</SettingsContainer>
	);
};

export default Settings;
